import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import TaskStatusBadge from '../../../shared/TaskStatusBadge';

export interface ProcessRunTaskStatusTask {
    instancePending?: boolean;
    instanceStatus?: number | null;
    dateEnd?: number | null;
}

interface ProcessRunTaskStatusProps {
    task: ProcessRunTaskStatusTask;
    pruned?: boolean;
}

const ProcessRunTaskStatus = ({ task, pruned = false }: ProcessRunTaskStatusProps) => {
    const { t } = useTranslation(['Tasks']);

    if (pruned) {
        return (
            <span className="badge task-status-badge task-status-badge--new">
                <SolarIcon name="slash-circle" className="me-1" />
                {t('status.pruned')}
            </span>
        );
    }

    if (task.instancePending) {
        return (
            <span className="badge task-status-badge task-status-badge--pending">
                <SolarIcon name="bi-hourglass-split" className="me-1" />
                {t('status.pending')}
            </span>
        );
    }

    if (task.instanceStatus == null || !Number.isFinite(Number(task.instanceStatus))) return null;

    return <TaskStatusBadge status={Number(task.instanceStatus)} dateEnd={task.dateEnd} />;
};

export default ProcessRunTaskStatus;
